import { validationRules } from "./constants";

const formValidation = {
  firstName: {
    required: "Please enter first name.",
    pattern: {
      value: /^[a-zA-Z]+$/,
      message: "Invalid first name.",
    },
    minLength: {
      value: 2,
      message: "First name should contain at least 2 characters.",
    },
    maxLength: {
      value: 15,
      message: "First name should not exceed 15 characters.",
    },
    validate: (value) => {
      return value.trim() ? true : "White spaces not allowed.";
    },
  },
  lastName: {
    required: "Please enter last name.",
    pattern: {
      value: /^[a-zA-Z]+$/,
      message: "Invalid last name.",
    },
    minLength: {
      value: 2,
      message: "Last name should contain at least 2 characters.",
    },
    maxLength: {
      value: 15,
      message: "Last name should not exceed 15 characters.",
    },
    validate: (value) => {
      return value.trim() ? true : "White spaces not allowed.";
    },
  },
  description: {
    required: "Message is required.",
    minLength: {
      value: 2,
      message: "Minimum length must be 2.",
    },
    validate: (value) => {
      return value.trim() ? true : "White spaces not allowed.";
    },
  },
  descriptionAr: {
    required: "Message in arabic is required.",
    minLength: {
      value: 2,
      message: "Minimum length must be 2.",
    },
    validate: (value) => {
      return value.trim() ? true : "White spaces not allowed.";
    },
  },
  email: {
    required: "Please enter email ID.",
    pattern: {
      value: validationRules.email,
      message: "Please enter valid email ID as: example@domain.com.",
    },
  },
  mobile: {
    required: "Please enter mobile number.",
    minLength: {
      value: 9,
      message: "Minimum length should be 9 digits.",
    },
    maxLength: {
      value: 12,
      message: "Maximum length should be 12 digits.",
    },
  },
  address: {
    required: "Address is required.",
    minLength: {
      value: 2,
      message: "Address should contains at least 2 characters.",
    },
    maxLength: {
      value: 200,
      message: "Address should not exceed 200 characters.",
    },
    validate: (value) => {
      return value.trim() ? true : "White spaces not allowed.";
    },
  },
  subjectLine: {
    required: " Subject Line is required.",
    minLength: {
      value: 2,
      message: "Minimum length must be 2.",
    },
    validate: (value) => {
      return value.trim() ? true : "White spaces not allowed.";
    },
  },
  name: {
    required: "Please enter subcategory.",
    pattern: {
      value: /^[a-zA-Z ]+$/,
      message: "Invalid category name.",
    },
    validate: (value) => {
      return value.trim() ? true : "White spaces not allowed.";
    },
  },
  property: {
    required: "Please enter property category.",
    // pattern: {
    //   value: /^[a-zA-Z ]+$/,
    //   message: 'Invalid property category.'
    // },
    validate: (value) => {
      return value.trim() ? true : "White spaces not allowed.";
    },
  },

  reason: {
    required: "Please enter reason.",
    pattern: {
      value: /^[a-zA-Z ]+$/,
      message: "Invalid reason.",
    },
    validate: (value) => {
      return value.trim() ? true : "White spaces not allowed.";
    },
  },
  reasonAr: {
    required: "Please enter reason.",
    validate: (value) => {
      return value.trim() ? true : "White spaces not allowed.";
    },
  },
  nameAr: {
    required: "Please enter subcategory in arabic.",
    validate: (value) => {
      return value.trim() ? true : "White spaces not allowed.";
    },
  },
  propertyAr: {
    required: "Please enter property category in arabic.",
    validate: (value) => {
      return value.trim() ? true : "White spaces not allowed.";
    },
  },
  shortName: {
    required: "Please enter short name.",
    pattern: {
      value: /^[^\s]+$/,
      message: "Please do not add space.",
    },
    validate: (value) => {
      return value.trim() ? true : "White spaces not allowed.";
    },
  },
  username: {
    required: "Please enter username.",
    pattern: {
      value: /^[^\s].*/,
      message: "Cannot start with a space.",
    },
    minLength: {
      value: 2,
      message: "Minimum length must be 2.",
    },
    validate: (value) => {
      return value.trim() ? true : "White spaces not allowed.";
    },
  },

  title: {
    required: "Please enter title.",
    pattern: {
      value: /^[^\s].*/,
      message: "Cannot start with a space.",
    },
    minLength: {
      value: 2,
      message: "Minimum length must be 2.",
    },
    validate: (value) => {
      return value.trim() ? true : "White spaces not allowed.";
    },
  },
  titleAr: {
    required: "Please enter title in arabic.",
    pattern: {
      value: /^[^\s].*/,
      message: "Cannot start with a space.",
    },
    minLength: {
      value: 2,
      message: "Minimum length must be 2.",
    },
    validate: (value) => {
      return value.trim() ? true : "White spaces not allowed.";
    },
  },
  charges: {
    required: "Charges is required.",
    minLength: {
      value: 2,
      message: "Minimum length must be 2.",
    },
  },
  redirectLink: {
    required: "Redirect Link is required.",
    minLength: {
      value: 2,
      message: "Minimum length must be 2.",
    },
    validate: (value) => {
      return value ? true : "White spaces not allowed.";
    },
    pattern: {
      value:
        /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g,
      message: "Invalid url (Ex: https://www.google.com/).",
    },
  },
  recordId: {
    required: "Record Id is required.",
    minLength: {
      value: 2,
      message: "Minimum length must be 2.",
    },
  },
  screenName: {
    required: "Screen Name is required.",
    minLength: {
      value: 2,
      message: "Minimum length must be 2.",
    },
  },
  brn: {
    required: "Please enter brn number.",
    minLength: {
      value: 4,
      message: "Min length should be 4 digits.",
    },
    maxLength: {
      value: 10,
      message: "Max length should be 10 digits.",
    },
  },
  designation: {
    required: "designation name is required.",
    pattern: {
      value: /^[a-zA-Z ]+$/,
      message: "Invalid designation.",
    },
    minLength: {
      value: 2,
      message: "Minimum length must be 2.",
    },
    validate: (value) => {
      return value.trim() ? true : "White spaces not allowed.";
    },
  },
  designationAr: {
    required: "designation name is required.",
    minLength: {
      value: 2,
      message: "Minimum length must be 2.",
    },
    validate: (value) => {
      return value.trim() ? true : "White spaces not allowed.";
    },
  },
  country: {
    required: "country is required.",
    validate: (value) => {
      return value ? true : "White spaces not allowed.";
    },
  },
  nationality: {
    required: "nationality is required.",
    validate: (value) => {
      return value ? true : "White spaces not allowed.";
    },
  },
  status: {
    required: "status is required.",
    validate: (value) => {
      return value ? true : "White spaces not allowed.";
    },
  },
  projectStatus: {
    required: "Please select project status.",
    validate: (value) => {
      return value ? true : "White spaces not allowed.";
    },
  },
  projectType: {
    required: "Please select project type.",
    validate: (value) => {
      return value ? true : "White spaces not allowed.";
    },
  },
  propertyPlanId: {
    required: "Please select property plan.",
    // validate: value => {
    //   return value ? true : 'White spaces not allowed.'
    // }
  },
  parkingType: {
    required: "Please select parking type.",
    validate: (value) => {
      return value ? true : "White spaces not allowed.";
    },
  },
  furnished: {
    required: "Please select furniture.",
    validate: (value) => {
      return value ? true : "White spaces not allowed.";
    },
  },
  financialStatus: {
    required: "Please select financial status.",
    validate: (value) => {
      return value ? true : "White spaces not allowed.";
    },
  },
  stage: {
    required: "Please select stage.",
    validate: (value) => {
      return value ? true : "White spaces not allowed.";
    },
  },
  parking: {
    required: "Please select parking.",
    validate: (value) => {
      return value ? true : "White spaces not allowed.";
    },
  },
  readyStage: {
    required: "Please select ready stage.",
    validate: (value) => {
      return value ? true : "White spaces not allowed.";
    },
  },
  propertyTypeId: {
    required: "Please select property type.",
    validate: (value) => {
      return value ? true : "White spaces not allowed.";
    },
  },
  city: {
    required: "Please select city.",
  },
  addressCity: {
    required: "Please enter city name.",
    validate: (value) => {
      return value ? true : "White spaces not allowed.";
    },
  },
  addressCityAr: {
    required: "Please enter city name in arabic.",
    validate: (value) => {
      return value ? true : "White spaces not allowed.";
    },
  },
  latitude: {
    required: "Please enter latitude.",
    validate: (value) => {
      return value ? true : "White spaces not allowed.";
    },
    pattern: {
      value: /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?)$/,
      message: "Invalid latitude.",
    },
  },
  longitude: {
    required: "Please enter longitude.",
    validate: (value) => {
      return value ? true : "White spaces not allowed.";
    },
    pattern: {
      value: /^[-+]?((1[0-7]|[1-9])?\d(\.\d+)?|180(\.0+)?)$/,
      message: "Invalid longitude.",
    },
  },
  community: {
    required: "Select Community",
  },
  language: {
    required: "language name is required.",
    validate: (value) => {
      return value ? true : "White spaces not allowed.";
    },
  },
  layoutType: {
    required: "Please select layout type.",
  },
  layoutTypeAr: {
    required: "Please select layout type in arabic.",
  },
  cheques: {
    // required: 'Please enter cheque.',
    validate: (value) => {
      return value ? true : "White spaces not allowed.";
    },
  },
  price: {
    required: "Please enter price.",
    validate: (value) => {
      return value ? true : "White spaces not allowed.";
    },
  },
  priceDaily: {
    required: "Please enter daily price.",
    validate: (value) => {
      return value ? true : "White spaces not allowed.";
    },
  },
  priceWeekly: {
    required: "Please enter weekly price.",
    validate: (value) => {
      return value ? true : "White spaces not allowed.";
    },
  },
  priceMonthly: {
    required: "Please enter monthly price.",
    validate: (value) => {
      return value ? true : "White spaces not allowed.";
    },
  },
  priceYearly: {
    required: "Please enter yearly price.",
    validate: (value) => {
      return value ? true : "White spaces not allowed.";
    },
  },
  permitNumber: {
    required: "Please enter permit number.",
    // minLength: {
    //   value: 4,
    //   message: 'Min length should be 4 digits.'
    // },
    // maxLength: {
    //   value: 10,
    //   message: 'Max length should be 10 digits.'
    // },
    validate: (value) => {
      return value ? true : "White spaces not allowed.";
    },
  },
  pricePerUnit: {
    required: "Please enter price per unit.",
    validate: (value) => {
      return value ? true : "White spaces not allowed.";
    },
    // pattern: {
    //   value: /^[1-9][1-9]*[.]?[1-9]{0,2}$/,
    //   message: 'Only two digits are allowed after decimal point.'
    // },
  },
  biddingFees: {
    required: "Please enter bidding fees.",
    validate: (value) => {
      return value ? true : "White spaces not allowed.";
    },
  },
  serviceCharge: {
    required: "Please enter service charge.",
    validate: (value) => {
      return value ? true : "White spaces not allowed.";
    },
    pattern: {
      value: /^[1-9]\d*(\.\d+)?$/,
      message: "Invalid input.",
    },
  },
  securityDeposit: {
    required: "Please enter security deposit amount.",
    validate: (value) => {
      return value ? true : "White spaces not allowed.";
    },
  },
  agentFirstName: {
    required: "Please enter agent first name.",
    pattern: {
      value: /^[a-zA-Z ]+$/,
      message: "Invalid agent first name.",
    },
    validate: (value) => {
      return value.trim() ? true : "White spaces not allowed.";
    },
  },
  agentFirstNameAr: {
    required: "Please enter agent first name.",
    validate: (value) => {
      return value.trim() ? true : "White spaces not allowed.";
    },
  },
  agentLastName: {
    required: "Please enter agent last name.",
    pattern: {
      value: /^[a-zA-Z ]+$/,
      message: "Invalid agent first name.",
    },
    validate: (value) => {
      return value.trim() ? true : "White spaces not allowed.";
    },
  },
  agentLastNameAr: {
    required: "Please enter agent last name.",
    validate: (value) => {
      return value.trim() ? true : "White spaces not allowed.";
    },
  },
  lat: {
    pattern: {
      value: /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?)$/,
      message: "Invalid latitude.",
    },
  },
  lng: {
    pattern: {
      value:
        /^(-?)(?:180(?:(?:\.0{1,15})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\.[0-9]{1,15})?))$/,
      message: "Invalid longitude.",
    },
  },
  minBedrooms: {
    required: "Please enter minimum bedrooms.",
    validate: (val) => {
      if (val <= 0) {
        return "value must be greater than 0.";
      }
    },
  },
  minBathrooms: {
    required: "Please enter minimum bathrooms.",
    validate: (val) => {
      if (val <= 0) {
        return "value must be greater than 0.";
      }
    },
  },
  minLivingRooms: {
    // required: 'Please enter minimum living rooms.',
    validate: (val) => {
      if (val <= 0) {
        return "value must be greater than 0.";
      }
    },
  },
  minGuestRooms: {
    required: "Please enter minimum guest rooms.",
    validate: (val) => {
      if (val <= 0) {
        return "value must be greater than 0.";
      }
    },
  },
  minPropertySize: {
    required: "Please enter minimum property size.",
    validate: (val) => {
      if (val <= 0) {
        return "value must be greater than 0.";
      }
    },
  },
  noOfAgents: {
    required: "No. of agents is required.",
  },
  noOfProperties: {
    required: "No. of properties is required.",
    validate: (value) => {
      return value.trim() ? true : "White spaces not allowed.";
    },
  },
  days: {
    required: "Days is required.",
    validate: (value) => {
      return value.trim() ? true : "White spaces not allowed.";
    },
  },
  type: {
    required: "Subscription type is required.",
    validate: (value) => {
      return value ? true : "White spaces not allowed.";
    },
  },
  packagePrice: {
    required: "Please enter package price.",
    validate: (val) => {
      if (val <= 0) {
        return "Value must be greater than 0.";
      }
    },
  },
  agentListing: {
    required: "Please enter agent listing.",
    validate: (val) => {
      if (val <= 0) {
        return "Value must be greater than 0.";
      }
    },
  },
  propertyListing: {
    required: "Please enter property listing.",
    validate: (val) => {
      if (val <= 0) {
        return "Value must be greater than 0.";
      }
    },
  },
  street: {
    // required: 'Please enter street.',
    // validate: value => {
    //   return value ? true : 'White spaces not allowed.'
    // }
  },
  unitNumber: {
    // required: 'Please enter unit number.',
    // validate: value => {
    //   return value ? true : 'White spaces not allowed.'
    // }
  },
  referenceNumber: {
    required: "Please enter reference number.",
    validate: (value) => {
      return value.trim() ? true : "White spaces not allowed.";
    },
  },
  trakheesiPermitNumber: {
    required: "Please enter trakheesi permit number.",
    validate: (value) => {
      return value.trim() ? true : "White spaces not allowed.";
    },
  },
  streetWidth: {
    // required: 'Please enter street width.',
    // validate: value => {
    //   return value.trim() ? true : 'White spaces not allowed.'
    // }
  },
  streetName: {
    // required: 'Please enter street name.',
    // validate: value => {
    //   return value.trim() ? true : 'White spaces not allowed.'
    // }
  },
  postalCode: {
    // required: 'Please enter postal code.',
    // validate: value => {
    //   return value.trim() ? true : 'White spaces not allowed.'
    // }
  },
  buildingNo: {
    // required: 'Please enter building number.',
    // validate: value => {
    //   return value.trim() ? true : 'White spaces not allowed.'
    // }
  },
  additionalNo: {
    // required: 'Please enter additional number.',
    // validate: value => {
    //   return value.trim() ? true : 'White spaces not allowed.'
    // }
  },
  northLimitDescription: {
    // required: 'Please enter north limit description.',
  },
  northLimitName: {
    // required: 'Please enter north limit name.',
  },
  northLimitLengthChar: {
    // required: 'Please enter north limit length.',
  },
  northLimitNameAr: {
    // required: 'Please enter north limit name in arabic.',
  },
  northLimitDescriptionAr: {
    // required: 'Please enter north limit description in arabic.',
  },
  northLimitLengthCharAr: {
    // required: 'Please enter north limit length in arabic.',
  },
  southLimitName: {
    // required: 'Please enter south limit name.',
  },
  southLimitDescription: {
    // required: 'Please enter south limit description.',
  },
  southLimitLengthChar: {
    // required: 'Please enter south limit length.',
  },
  southLimitNameAr: {
    // required: 'Please enter south limit name in arabic.',
  },
  southLimitDescriptionAr: {
    // required: 'Please enter south limit description in arabic.',
  },
  southLimitLengthCharAr: {
    // required: 'Please enter south limit length in arabic.',
  },
  eastLimitName: {
    // required: 'Please enter east limit name.',
  },
  eastLimitDescription: {
    // required: 'Please enter east limit description.',
  },
  eastLimitLengthChar: {
    // required: 'Please enter east limit length.',
  },
  eastLimitNameAr: {
    // required: 'Please enter east limit name in arabic.',
  },
  eastLimitDescriptionAr: {
    // required: 'Please enter east limit description in arabic.',
  },
  eastLimitLengthCharAr: {
    // required: 'Please enter east limit length in arabic.',
  },
  westLimitName: {
    // required: 'Please enter west limit name.',
  },
  westLimitDescription: {
    // required: 'Please enter west limit description.',
  },
  westLimitLengthChar: {
    // required: 'Please enter west limit length.',
  },
  westLimitNameAr: {
    // required: 'Please enter west limit name in arabic.',
  },
  westLimitDescriptionAr: {
    // required: 'Please enter west limit description in arabic.',
  },
  westLimitLengthCharAr: {
    // required: 'Please enter west limit length in arabic.',
  },
  propertyLength: {
    // required: 'Please enter property length.',
    // validate: value => {
    //   return value ? true : 'White spaces not allowed.'
    // }
  },
  propertyWidth: {
    // required: 'Please enter property width.',
    // validate: value => {
    //   return value ? true : 'White spaces not allowed.'
    // }
  },
  propertyAge: {
    // required: 'Please enter unit property age.',
    // validate: value => {
    //   return value ? true : 'White spaces not allowed.'
    // }
  },
  building: {
    // required: 'Please enter building.',
    // validate: value => {
    //   return value ? true : 'White spaces not allowed.'
    // }
  },
  subFirstName: {
    required: "Please enter first name.",
    pattern: {
      value: /^[a-zA-Z]+$/,
      message: "Invalid first name.",
    },
    minLength: {
      value: 2,
      message: "First name should contain at least 2 characters.",
    },
    maxLength: {
      value: 256,
      message: "First name should not exceed 256 characters.",
    },
    validate: (value) => {
      return value.trim() ? true : "White spaces not allowed.";
    },
  },
  subLastName: {
    required: "Please enter last name.",
    pattern: {
      value: /^[a-zA-Z]+$/,
      message: "Invalid last name.",
    },
    minLength: {
      value: 2,
      message: "Last name should contain at least 2 characters.",
    },
    maxLength: {
      value: 256,
      message: "Last name should not exceed 256 characters.",
    },
    validate: (value) => {
      return value.trim() ? true : "White spaces not allowed.";
    },
  },
  slug: {
    required: "Please enter slug.",
    minLength: {
      value: 2,
      message: "Minimum length must be 2.",
    },
    validate: (value) => {
      const slugPattern = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
      if (!slugPattern.test(value)) {
        return "Invalid slug (eg.hello-world)";
      }
    },
  },
  slugAr: {
    required: "Please enter slug in arabic.",
    minLength: {
      value: 2,
      message: "Minimum length must be 2.",
    },
    // pattern:{
    //   value:/^[^\s]+$/,
    //   message:'no space allowed'
    // }
  },
  owner_name: {
    // required: 'Please enter owner name.',
    pattern: {
      value: /^[a-zA-Z ]+$/,
      message: "Invalid owner name.",
    },
    validate: (value) => {
      if (!value) return true;
      return value.trim() ? true : "White spaces not allowed.";
    },
  },
  owner_email: {
    pattern: {
      value: validationRules.email,
      message: "Please enter valid email ID as: example@domain.com.",
    },
  },
  owner_phone: {
    minLength: {
      value: 9,
      message: "Minimum length should be 9 digits.",
    },
    maxLength: {
      value: 12,
      message: "Maximum length should be 12 digits.",
    },
  },
  specializedArea: {
    required: "Please select specialized area.",
    // pattern: {
    //   value: /^[a-zA-Z ]+$/,
    //   message: 'Invalid property category.'
    // },
    validate: (value) => {
      return value.trim() ? true : "White spaces not allowed.";
    },
  },
  // description: {
  //   required: 'Description is required.',
  //   validate: value => {
  //     return value.trim() ? true : 'White spaces not allowed.'
  //   }
  // },
  licenseNumber: {
    required: "Please enter license number.",
    validate: (value) => {
      return value ? true : "White spaces not allowed.";
    },
  },
  availableStatus: {
    required: "Please select project available status.",
    validate: (value) => {
      return value ? true : "White spaces not allowed.";
    },
  },
};

export default formValidation;
